// extracted by mini-css-extract-plugin
export default {"blueBadge":"StopLossList_blueBadge__qnvGV"};